import Splide from "@splidejs/splide";

window.bootstrap = require("bootstrap/dist/js/bootstrap.bundle.js");

/* SCROLL TO */
window.goTo = function(target) {
    console.log(target, event)
    event.preventDefault()
    
    var headerOffset = 110;
    setTimeout(function() {
        var elementPosition = target.getBoundingClientRect().top;
        var offsetPosition = elementPosition - headerOffset;
        const startPos = window.pageYOffset;
        
        console.log(offsetPosition)
    
        window.scrollTo({
            top: startPos + offsetPosition,
            behavior: "smooth"
        });
        
    }, 400);
    
    
  }

const appHeight = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
};

window.addEventListener("resize", appHeight);
appHeight();

function animate() {
    let overlay = document.querySelector("#banner-overlay");

    overlay.classList.add("show");
}

function calcLength(newIndex, total) {
    return `${(newIndex / total) * 100}%`;
}

function makeBannerSplide() {
    let progresssion = document.querySelector("#progression span");
    let sliderCount = document.querySelectorAll("#banner li").length;

    let splide = new Splide("#banner-slider", {
        pagination: false,
        autoplay: true,
        interval: 6000,
        rewind: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        type: "fade",
        arrows: true,
        height: "100vh",
        easing: "cubic-bezier(0.8, 0.2, 0.2, 0.8)",
    })
        .on("mounted", function (newIndex) {
            progresssion.style.width = calcLength(1, sliderCount);
        })
        .on("move", function (newIndex) {
            progresssion.style.width = calcLength(newIndex + 1, sliderCount);
        });

    splide.mount();
}

function makeHighlightSplide() {
    if (document.getElementById("highlight-slider") === null) {
        return false;
    }
    let splide = new Splide("#highlight-slider", {
        autoplay: true,
        interval: 5000,
        pagination: false,
        rewind: true,
        gap: 27,
        padding: { left: 0, right: 45 },
        perPage: 1,
        mediaQuery: "min",
        breakpoints: {
            1280: {
                perPage: 3,
                perMove: 1,
                gap: 30,
                padding: { left: 0, right: 103 },
            },
            1024: {
                perPage: 2,
                perMove: 1,
                arrows: true,
                gap: 30,
                //height: 500,
                padding: { left: 0, right: 180 },
            },
            768: {
                perPage: 1,
                perMove: 1,
                arrows: true,
                gap: 30,
                //height: 500,
                padding: { left: 0, right: 180 },
            },
        },
    });

    splide.mount();
}

function makeValuesSplide() {
    let panesBtn = document.querySelectorAll('button[data-bs-toggle="tab"]');
    let valuesCounter = document.getElementById("values-counter");

    if (document.getElementsByClassName("splide").length < 1) {
        return false;
    }

    let splide = new Splide(".splide", {
        autoplay: true,
        interval: 4000,
        rewind: true,
        pagination: false,
        breakpoints: {
            2000: {
                destroy: true,
                perPage: 5,
                pagination: false,
                autoWidth: true,
                autoplay: false,
            },
            767: {
                destroy: false,
                autoplay: false,
            },
        },
    })

        //update tab on slide
        .on("move", function (newIndex, prev, dest) {
            let tab = new bootstrap.Tab(panesBtn[newIndex]);
            tab.show();
            valuesCounter.textContent = newIndex + 1;
        })
        .on("mounted", function (index) {});
    splide.mount();

    function setTabByInterval() {
        let activeTab = document.querySelector(
            'button[data-bs-toggle="tab"].active'
        );
        let newTab = null;
        newTab = activeTab.parentNode.nextElementSibling;

        if (newTab != undefined) {
            let tab = bootstrap.Tab.getOrCreateInstance(newTab.children[0]);
            tab.show();
        } else {
            let tab = bootstrap.Tab.getOrCreateInstance(panesBtn[0]);
            tab.show();
        }
    }

    panesBtn.forEach(function (tab, index) {
        tab.addEventListener("shown.bs.tab", function (event) {
            valuesCounter.textContent = index + 1;
        });
    });

    if (window.innerWidth > 767) {
        let valuesInterval = setInterval(function () {
            setTabByInterval();
        }, 2000);
        let valuesSection = document.querySelector("#values .container-fluid");

        valuesSection.addEventListener("mouseleave", function (e) {
            valuesInterval = setInterval(function () {
                setTabByInterval();
            }, 2000);
        });
        valuesSection.addEventListener("mouseenter", function (e) {
            clearInterval(valuesInterval);
        });
    }

    document.querySelectorAll("#nav .btn").forEach(function (btn) {
        btn.addEventListener("click", function (e) {
            let activeTab = document.querySelector(
                'button[data-bs-toggle="tab"].active'
            );
            let newTab = null;

            if (btn.dataset.direction == "prev") {
                newTab = activeTab.parentNode.previousElementSibling;
            } else {
                newTab = activeTab.parentNode.nextElementSibling;
            }

            if (newTab != undefined) {
                let tab = bootstrap.Tab.getOrCreateInstance(newTab.children[0]);
                tab.show();
            } else {
                if (btn.dataset.direction == "prev") {
                    let tab = bootstrap.Tab.getOrCreateInstance(panesBtn[3]);
                    tab.show();
                } else {
                    let tab = bootstrap.Tab.getOrCreateInstance(panesBtn[0]);
                    tab.show();
                }
            }
        });
    });
}

// NAV
let scrollpos = window.scrollY;
const header = document.querySelector("header");
const body = document.querySelector("body");

if (header != undefined) {
    const header_height = 60;
    const add_class_on_scroll = () => header.classList.add("nav-scroll");
    const remove_class_on_scroll = () => header.classList.remove("nav-scroll");

    window.addEventListener("scroll", function () {
        scrollpos = window.scrollY;
        if (scrollpos >= header_height) {
            add_class_on_scroll();
        } else {
            remove_class_on_scroll();
        }
    });
}

// Toggle btn nav
const btnNav = document.getElementById("btn-nav");

btnNav.addEventListener("click", function () {
    var value = document
        .getElementById("btn-nav")
        .getAttribute("aria-expanded");
    var mainNav = document.getElementById("main-nav");

    if (value == "true") {
        btnNav.setAttribute("aria-expanded", "false");
        //mainNav.setAttribute("hidden", "");
        mainNav.classList.remove("open");
        body.classList.remove("backdrop");
    } else {
        btnNav.setAttribute("aria-expanded", "true");
        //mainNav.removeAttribute("hidden");
        mainNav.classList.add("open");
        body.classList.add("backdrop");
    }
});

var buttons = document.querySelectorAll("div.subs_row > div");

// Close Nav Click item
var navItems = document.querySelectorAll("nav .link");

navItems.forEach(function (close) {
    var value = document
        .getElementById("btn-nav")
        .getAttribute("aria-expanded");
    var mainNav = document.getElementById("main-nav");

    close.addEventListener("click", function () {
        btnNav.setAttribute("aria-expanded", "false");
        mainNav.classList.remove("open");
        body.classList.remove("backdrop");
        
        
    });
});

//

function dropdownToSelect() {
    let dropdownEls = document.querySelectorAll(".dropdown-select a");

    for (let i = 0; i < dropdownEls.length; i++) {
        dropdownEls[i].addEventListener("click", function (e) {
            let value = e.target.getAttribute("data-value");
            let input =
                e.target.parentNode.parentNode.getAttribute("data-input");
            let close = e.target.parentNode.parentNode.previousElementSibling;

            document.getElementsByName(input)[0].value = value;
            close.textContent = e.target.textContent;

            if (input === "type" && value === "entreprise") {
                document
                    .getElementById("recherche")
                    .parentNode.parentNode.classList.remove("d-none");
            }
            e.preventDefault();
        });
    }
}


function toggleHeaderBtns() {
    let tel = document.getElementById('btn-nav-tel');
    let contact = document.getElementById('btn-nav-contact');
    
    tel.addEventListener('mouseenter', function(e) {
        contact.classList.add('hide');
    });
    tel.addEventListener('mouseleave', function(e) {
        contact.classList.remove('hide');
    });
}
document.addEventListener("DOMContentLoaded", function () {
    makeBannerSplide();
    makeValuesSplide();
    makeHighlightSplide();
    dropdownToSelect();
    animate();
   // scrollToTarget();
    toggleHeaderBtns();
});

let map;

function initMap() {
    map = new google.maps.Map(document.getElementById("map"), {
        center: { lat: -34.397, lng: 150.644 },
        zoom: 8,
    });
}
